import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { List, ListItem, Typography } from '@mui/material';
import { Stack } from '@mui/system';

type SnackBarUpdateButtonTooltipProps = {
  stashedMetadata: Record<string, unknown>;
};

const SnackBarUpdateButtonTooltip: FC<SnackBarUpdateButtonTooltipProps> = ({
  stashedMetadata,
}) => {
  const { t } = useTranslation(['inventory', 'common']);

  const keys = Object.keys(stashedMetadata);

  return (
    <Stack sx={{ p: 1 }}>
      <Typography variant='caption' sx={{ fontWeight: 600 }}>
        {t('inventory:tooltipUpdateButton.title')}:
      </Typography>
      <List sx={{ p: 0 }}>
        <ListItem sx={{ p: 0 }}>
          {keys.length}{' '}
          {t('inventory:tooltipUpdateButton.addedModifiedMetadata')}
        </ListItem>
      </List>
    </Stack>
  );
};

export default SnackBarUpdateButtonTooltip;
